import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { Button, Col, Modal, Row, Typography } from 'antd'
import moment from 'moment'

import { integrationsService } from './../../redux/services'
import { UIDrawerForm, UIFormSection, UIInfoBanner } from './../../components'
import ColumnTable from './table'
import EventColumnTable from './tableEvents'
import LayoutPreview from './layoutPreview'

const { Text } = Typography

const SEPARATOR_NAMES = {
  ';': 'ponto e vírgula',
  ',': 'vírgula',
  '.': 'ponto',
  ':': 'dois-pontos',
  '|': 'barra vertical',
  '/': 'barra',
  '-': 'hífen',
  ' ': 'espaço',
}

class Show extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onEdit: PropTypes.func,
    external: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      uuid: 0,
      item: {},
      general_key: null,

      // dados das tabelas (somente leitura)
      eventData: [],
      columnDataIsLoading: false,
      eventColumnData: [],
      eventDataIsLoading: false,
      layoutRows: [],
      layoutTypeSections: [],
      layoutColumnOptions: [],
    }
  }

  handleTabClick = () => { }

  onOpen = (uuid, key) => {
    this.setState({
      isLoading: true,
      uuid,
      item: {},
      general_key: key,
      columnDataIsLoading: true,
      eventDataIsLoading: true,
    })

    integrationsService
      .show({ uuid })
      .then((response) => {
        const item = response?.data?.data ?? {}

        // suporta novo contrato (eventos.{columnData,eventColumnData}) e legados (na raiz)
        const ev = item?.eventos ?? {}

        const eventData =
          Array.isArray(ev?.eventData) ? ev.eventData : []

        const eventColumnData =
          Array.isArray(ev?.eventColumnData) ? ev.eventColumnData
            : Array.isArray(item?.columnData) ? item.columnData
              : []

        this.setState({
          isLoading: false,
          item,
          eventData,
          columnDataIsLoading: false,
          eventColumnData,
          eventDataIsLoading: false,
        })
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          columnDataIsLoading: false,
          eventDataIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(err),
          onOk: () => this.onClose(),
        })
      })
  }

  resetFields = () => {
    this.setState({ item: {} })
  }

  onClose = () => {
    this.resetFields()
    this.props.onClose()
  }

  onEdit = () => {
    this.props.onEdit(this.state.uuid)
  }

  onLayoutRowsChange = (layoutRows, layoutTypeSections, layoutColumnOptions) => {
    this.setState({ layoutRows, layoutTypeSections, layoutColumnOptions })
  }

  formatDMY = (d) => (d ? moment(d).format('DD/MM/YYYY') : '-')
  formatCalendar = (d) => (d ? moment(d).calendar() : '-')

  formatNames = (list, emptyLabel) => (list?.length > 0 ? list.map((entry) => entry.nome).join(', ') : emptyLabel)

  // Só exibe quando todas as colunas usam o mesmo separador
  getColumnSeparator = () => {
    const separators = [...new Set(this.state.eventData.map((row) => row?.separator ?? '').filter(Boolean))]

    return separators.length === 1 ? separators[0] : null
  }

  renderInfoItem = (icon, label, value) => (
    <div className="integration-view-info-item">
      <i className={`fal ${icon}`} />
      <div>
        <span className="integration-view-info-label">{label}</span>
        <span className="integration-view-info-value">{value}</span>
      </div>
    </div>
  )

  render() {
    const { visible, onEdit } = this.props
    const {
      isLoading,
      item,
      eventData,
      eventColumnData,
      layoutRows,
      layoutTypeSections,
      layoutColumnOptions,
    } = this.state

    const separator = this.getColumnSeparator()

    return (
      <UIDrawerForm
        visible={visible}
        width="min(1240px, 100%)"
        onClose={this.onClose}
        isLoading={isLoading}
        showBtnSave={false}
        icon={<i className="fal fa-plug" />}
        title="Visualizar Integração"
        subtitle="Consulte os detalhes da integração e o layout utilizado na geração do arquivo."
        extra={onEdit ? (
          <Button type="secondary" icon={<i className="fal fa-pen" />} onClick={this.onEdit}>
            Editar Integração
          </Button>
        ) : null}
      >
        <div className="integration-view-summary">
          <div className="integration-view-identity">
            <div className="integration-view-identity-icon">
              <i className="fal fa-plug" />
            </div>
            <div className="integration-view-identity-text">
              <Text ellipsis={{ tooltip: item.descricao }} className="integration-view-identity-title">{item.descricao || '-'}</Text>
              <span className="integration-view-identity-subtitle">Folha de Pagamento</span>
            </div>
          </div>
          <div className="integration-view-info">
            {this.renderInfoItem('fa-building', 'Empresa(s)', this.formatNames(item.empresas, 'Todas'))}
            {this.renderInfoItem('fa-sitemap', 'Departamento(s)', this.formatNames(item.departamentos, 'Todos'))}
            {this.renderInfoItem('fa-users', 'Funcionário(s)', this.formatNames(item.funcionarios, 'Todos'))}
            {this.renderInfoItem('fa-file-alt', 'Layout', item.layout || '-')}
          </div>
          <div className="integration-view-dates">
            {this.renderInfoItem('fa-calendar', 'Data do Cadastro', this.formatDMY(item.created_at))}
            {this.renderInfoItem('fa-clock', 'Última atualização', this.formatCalendar(item.updated_at))}
          </div>
        </div>

        <Row gutter={[16, 20]} className="integration-form">
          <Col xs={24} xl={12}>
            <UIFormSection
              icon={<i className="fal fa-columns" />}
              title="Estrutura do arquivo (layout)"
              description="Ordem e configuração das colunas que serão geradas no arquivo."
            >
              <ColumnTable eventData={eventData} readOnly onRowsChange={this.onLayoutRowsChange} />
              {separator && (
                <div className="integration-view-separator">
                  <i className="fal fa-info-circle" />
                  Separador de colunas:
                  <code>{separator}</code>
                  {SEPARATOR_NAMES[separator] && <span>({SEPARATOR_NAMES[separator]})</span>}
                </div>
              )}
            </UIFormSection>
            <UIFormSection icon={<i className="fal fa-align-left" />} title="Descrição">
              <p className="integration-view-description">{item.descricao || '-'}</p>
            </UIFormSection>
          </Col>
          <Col xs={24} xl={12}>
            <UIFormSection
              icon={<i className="fal fa-list-alt" />}
              title="Configuração de eventos"
              description="Relação dos eventos que serão integrados."
            >
              <EventColumnTable eventData={eventColumnData} readOnly />
            </UIFormSection>
            <UIFormSection
              icon={<i className="fal fa-eye" />}
              title="Pré-visualização do layout"
              description="Exemplo de como o registro será gerado no arquivo."
            >
              <LayoutPreview
                rows={layoutRows}
                typeSections={layoutTypeSections}
                columnOptions={layoutColumnOptions}
              />
            </UIFormSection>
          </Col>
        </Row>

        <div className="integration-view-banner">
          <UIInfoBanner
            icon={<i className="fal fa-shield-alt" />}
            title="Importante"
            description="Alterações no layout podem impactar a geração do arquivo. Recomendamos atenção ao editar."
          />
        </div>
      </UIDrawerForm>
    )
  }
}

export default Show
